.alerts {
	position: fixed;
	bottom: calc(var(--size-5) + var(--alerts-offset));
	right: var(--size-5);
	display: flex;
	flex-direction: column;
	gap: var(--size-4);
	max-width: 50vw;
}

.alertitem {
	--duration: 0.2s;
	transform-origin: center;
	translate: 0 0;
	transition:
		translate var(--duration),
		opacity var(--duration),
		scale var(--duration);

	&.alertAppear {
		translate: 0 80%;
		opacity: 0;
		scale: 0.9;
	}

	&.alertAppearActive {
		transform-origin: bottom;
		opacity: 1;
		scale: 1;
		translate: 0 0;
	}

	&.alertExitActive {
		--duration: 0.1s;
		opacity: 0;
		scale: 0.8;
		translate: 0 0;
	}
}

.alert {
	display: flex;
	gap: var(--size-3);
	align-items: center;
	padding-left: var(--size-4);
	padding-right: var(--size-3);
	background-color: var(--color-surface);
	box-shadow: var(--shadow-md);
	border: var(--size-border) solid var(--color-border);
	background-clip: padding-box;
	border-radius: var(--radius-md);
	min-width: 20rem;
	overflow: clip;
}

.icon {
	flex-shrink: 0;

	&[data-type="success"] {
		color: light-dark(var(--green-700), var(--green-500));
	}

	&[data-type="warning"] {
		color: light-dark(var(--orange-600), var(--orange-500));
	}

	&[data-type="error"] {
		color: var(--red-500);
	}
}

.label {
	display: block;
	padding: var(--size-4) 0;
	text-box: trim-both cap alphabetic;
	margin-right: auto;
	user-select: text;
}

.actions {
	display: flex;
	align-self: stretch;
	border-right: 1px solid var(--color-border);
}

.action {
	padding: 0 var(--size-3);
	display: block;
	height: 100%;
	background-color: transparent;
	border: none;
	border-left: 1px solid var(--color-border);

	&:hover {
		background-color: var(--color-surface-hover);
	}
}

.close {
	padding: var(--size-2);
	appearance: none;
	background-color: transparent;
	border: none;
	border-radius: 50%;
	corner-shape: round;

	&:hover {
		background-color: var(--color-border);
	}
}
